import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularQuestionCircle: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_question-circle"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="question-circle icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5ZM14 18.5C14.6904 18.5 15.25 19.0596 15.25 19.75C15.25 20.4404 14.6904 21 14 21C13.3096 21 12.75 20.4404 12.75 19.75C12.75 19.0596 13.3096 18.5 14 18.5ZM14 6.75C15.9625 6.75 17.75 8.47515 17.75 10.5C17.75 11.9315 17.2847 12.7736 16.2039 13.806L16.0068 13.9904L15.8028 14.1768C14.9974 14.9151 14.75 15.302 14.75 16C14.75 16.4142 14.4142 16.75 14 16.75C13.5858 16.75 13.25 16.4142 13.25 16C13.25 14.8513 13.6475 14.1579 14.5928 13.2547L15.1625 12.7266C15.9732 11.9548 16.25 11.4423 16.25 10.5C16.25 9.31571 15.1458 8.25 14 8.25C12.8542 8.25 11.75 9.31571 11.75 10.5C11.75 10.9142 11.4142 11.25 11 11.25C10.5858 11.25 10.25 10.9142 10.25 10.5C10.25 8.47515 12.0375 6.75 14 6.75Z" />
      </svg>
    </span>
  );
};

export { RegularQuestionCircle };
